import { Component, Input, OnInit } from '@angular/core';

import { map, catchError, finalize } from 'rxjs';

import { GeneralDynamicContent } from 'src/app/shared/entities/general-dynamic-content';
import { DynamicResourceService } from 'src/app/shared/services/dynamic-resource.service';

@Component({
  selector: 'app-general-dynamic-content-item',
  templateUrl: './general-dynamic-content-item.component.html',
  styleUrls: ['./general-dynamic-content-item.component.css']
})
export class GeneralDynamicContentItemComponent implements OnInit {
  @Input()
  element: GeneralDynamicContent;

  loaded = false; // Ressource
  imgLoaded = false; // Image affichée
  defaultImg = '/assets/images/Pas-dimage-disponible.jpg';

  get image() {
    // Si objet avec id => ressource. Si image == string => url externe
    return this.loaded ? this.element.image?.[0].url  : this.defaultImg;
  }

  get isResource() {
    return (this.element?.image?.resourcesId != null) && (this.element?.image?.[0].url != null)
  }

  get loading() {
    return !this.loaded && !this.imgLoaded
  }

  constructor(private dynamicResourceService: DynamicResourceService) { }

  ngOnInit(): void {
   
    if (this.element?.image?.id) {
      this.setImage(this.element.image.id);
    } else {
      this.loaded = true;
    }
  }

  setImage(ref: string) { // elementRef id = documentId
    this.dynamicResourceService.findById(ref, true).pipe(
      map((url: string) => {
        this.element.image = url;
      }),
      catchError((error) => {
        let err: string = error?.error ? error?.error.text : error.text;
        if (err) {
          this.element.image = err;
        }
        throw error;
      }),
      finalize(() => {
        this.loaded = true;
      })
    ).subscribe()
  }

}
